import React from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import { Icon } from "@widgets/common/components/primitives/icon";

import styles from "./link.css";

export const LINK_SIZE = {
  BASE: "base",
  MEDIUM: "medium",
  SMALL: "small",
  TINY: "tiny",
  MICRO: "micro"
};

export function Link(props) {
  const {
    children,
    href,
    route,
    target = "_blank",
    className,
    onClick,
    onMouseOver,
    onMouseLeave,
    onFocus,
    onBlur,
    id = "",
    leftIcon,
    rightIcon,
    size = LINK_SIZE.BASE
  } = props;
  return route ? (
    <RouterLink
      className={`${styles.link} ${className}
        ${(leftIcon || rightIcon) && styles.withicon} 
      `}
      to={route}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      data-component="link"
      id={id}
    >
      {leftIcon && (
        <Icon paddingNone={true} className={styles.leftIcon}>
          {leftIcon}
        </Icon>
      )}
      {children}
      {rightIcon && (
        <Icon paddingNone={true} className={styles.rightIcon}>
          {rightIcon}
        </Icon>
      )}
    </RouterLink>
  ) : (
    <a
      className={`${styles.link} ${className}
        ${(leftIcon || rightIcon) && styles.withicon} ${styles[`${size}`]}
      `}
      href={href}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          onClick(e);
        }
      }}
      onMouseOver={onMouseOver}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      target={target}
      data-component="link"
      id={id}
    >
      {leftIcon && (
        <Icon paddingNone={true} className={styles.leftIcon}>
          {leftIcon}
        </Icon>
      )}
      {children}
      {rightIcon && (
        <Icon paddingNone={true} className={styles.rightIcon}>
          {rightIcon}
        </Icon>
      )}
    </a>
  );
}

Link.propTypes = {
  /** Size of the nav (base | medium | small | tiny | micro) */
  size: PropTypes.string,
  /** The visible content of the link */
  children: PropTypes.node.isRequired,
  /** Actual url*/
  href: PropTypes.string,
  /** Flag to differentiate normal link and React route link  */
  route: PropTypes.string,
  /** The Browser link target open type */
  target: PropTypes.string,
  /** Classname to modify style of a link component */
  className: PropTypes.string,
  /** Id attribute for link component */
  id: PropTypes.string,
  /** Left icon component, it will added in front of a link */
  leftIcon: PropTypes.node,
  /** Right icon component, it will added end of a link */
  rightIcon: PropTypes.node,
  /** A callback function that gets invoked when the user clicks the link. */
  onClick: PropTypes.func,
  /** A callback function that gets invoked when the mouse enters on top of the link. */
  onMouseOver: PropTypes.func,
  /** A callback function that gets invoked when the mouse moves out of the link after entering on top the link. */
  onMouseLeave: PropTypes.func,
  /** A callback function that gets invoked When the link gets focused. Press Tab key, the browswer will focus the links present on the page one by one. */
  onFocus: PropTypes.func,
  /** A callback function that gets invoked When the focus shifts away from the link. Press Tab key when the focus is on the link to focus the next link. */
  onBlur: PropTypes.func
};

Link.defaultProps = {
  target: "_blank",
  id: "",
  size: LINK_SIZE.BASE
};
